<div class="w-full px-5 py-3">
    <div class="w-full flex justify-between mb-12" *ngIf="showHeader">
        <div>
            <div class="flex items-center mb-1">
                <a class="text-sm text-black">Templates</a>
            </div>
            <h1 class="font-bold text-2xl">Seus Templates</h1>
        </div>

    </div>
    <div *ngIf="searchTerm === undefined " class="h-full w-full flex justify-center ">
        <div class="w-2/3 flex flex-col justify-center items-center">
            <img src="/assets/img/Warning.svg" alt="Imagem de alertas">
            <h1 class="mt-3 font-semibold text-2xl text-center">Parece que você ainda não cadastrou nenhum Template
            </h1>
            <span class="mt-3 text-sm text-black font-medium">Cadastre seu primeiro Template.</span>
            <button (click)="onClick()"
                class="mt-3 text-sm bg-indigo-600 hover:bg-indigo-500 cursor-pointer text-white font-semibold rounded-md py-2 px-4">Criar
                Template</button>
        </div>
    </div>

    <div *ngIf="searchTerm !== undefined" class="h-full w-full flex justify-center ">
        <div class="w-2/3 flex flex-col justify-center items-center">
            <img src="/assets/img/Warning.svg" alt="Imagem de alertas">
            <h1 class="mt-3 font-semibold text-2xl text-center">Nenhum template encontrado com essa busca!</h1>
        </div>
    </div>
</div>